<template>
  <div>
    <v-card hover :loading="loading" class="bg-light" @click="navigateToComponent">
      <v-card-text>
        <h5>{{ title }}</h5>
        <h6 class="text-info">{{ data }}</h6>
        <p>{{ description }}</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SimpleDataCard",
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: String,
      default: '0'
    },
    description: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    route: {
      type: String,
      default: null,
    }
  },
  methods: {
    navigateToComponent() {
      if (this.route === null) return
      this.$router.push(this.route)
    }
  }
}
</script>

<style scoped>

</style>